<!-- 添加商品 -->
<template>
  <div>
    <a-product></a-product>
  </div>
</template>

<script>
import aProduct from "@Components/public/aProduct"
export default {
  data () {
    return {
    };
  },
  components: {
    aProduct,
  }
}
</script>
<style lang= "scss" scoped>
</style>